export const reduceText = (str: string, max: number): string => {
  if (str.length < max) {
    return str;
  }

  return `${str.substring(0, max - 2)}...`;
};

export const isSWHeader = (name: string): string =>
  name
    .split("_")
    .map((it) => it.charAt(0).toUpperCase() + it.slice(1))
    .join(" ");

export const stringContainsAnyCharacters = (
  stringToCheck: string,
  charactersAsString: string
): boolean => {
  if (Array.from(charactersAsString).some((el) => stringToCheck.includes(el))) {
    return true;
  }
  return false;
};
